<script>

  const _nullTable = {
    "GanttBarTexts": [],
    "RowReferences": [],
    "PosReferences": []
  };

  import GeneralInput from "../input/GeneralInput.svelte";
  import GeneralButton from "../button/GeneralButton.svelte";
  import GeneralImgButton from "../button/GeneralImgButton.svelte";
  import GeneralSelect from "../select/GeneralSelect.svelte";
  import { SelectRectangle } from "../../utils/selectRectangle";

  import {translate} from "../../i18n/i18next.js";

  export let GanttStore;
  export let CloseCallback;
  export let Toggled;

  const {
    RowsAllFiltered,
    RowsDisplayedStart,
    RowsCached,
    CurrentDisplayedStartDate,
    CurrentDisplayedEndDate,
    ValidStartDate,
    ValidEndDate,
    DisplayedRowCount,
    SearchTables,
    CurrentStyle,
  } = GanttStore;

  $: if ($RowsAllFiltered) HighlightMatch();

  // Operation: ope, Row: row
  let tab = "ope";

  let caseSensitive = false;

  const conditionOptions = [
    {translationKey: "frontend:components.filterDialog.conditions.contains", value: "contains"},
    {translationKey: "frontend:components.filterDialog.conditions.equals", value: "equals"},
    {translationKey: "frontend:components.filterDialog.conditions.starts", value: "starts"},
    {translationKey: "frontend:components.filterDialog.conditions.ends", value: "ends"},
  ];

  let matchCount = 0;
  let currentMatch = 0;
  let matchs = [];

  // Operation
  $: dataTipCondition = "contains";
  $: dataTipValue = "";

  // Row
  $: rowCondition = "contains";
  $: rowValue = "";

  const JumpToDate = (match) => {
    const _obj = $RowsCached[match[0]]?.Data[match[1]] ?? null;
    if (_obj === null) return;

    // Center X
    const _center = ($CurrentDisplayedEndDate - $CurrentDisplayedStartDate) / 2;
    const _pos = Math.max(
      $ValidStartDate,
      Math.min(
        $ValidEndDate,
        _obj._productionArr[0] - _center
      )
    );
    console.log(new Date(_pos));
    GanttStore.CurrentDisplayedStartDate.set(new Date(_pos));

    // Center Y
    const _yOffset = Math.floor($DisplayedRowCount / 2);
    const _index = $RowsAllFiltered.findIndex((el) => el.Row === _obj._row);
    if (_index >= 0) {
      GanttStore.RowsDisplayedStart.update((_) => Math.max(0, _index - _yOffset));
    }
    else {
      console.warn("Filtered row");
      // Display warning notification
    }

    SelectRectangle.ForceSelect([_obj._objectID], _obj._row);
  };

  const JumpToRow = (rowIdx) => {
    GanttStore.RowsDisplayedStart.update((_) => rowIdx);
  };

  const CheckMatchingCondition = (needle, haystack, condition) => {
    const _haystack = caseSensitive === true ? haystack : haystack.toUpperCase();
    const _needle = caseSensitive === true ? needle : needle.toUpperCase();

    if (!/\S/.test(_haystack) || !/\S/.test(_needle)) return false;

    switch (condition) {
      case "starts":
        return _haystack.startsWith(_needle);
      case "ends":
        return _haystack.endsWith(_needle);
      case "equals":
        return _haystack === _needle;
      case "contains":
      default:
        return _haystack.includes(_needle);
    }
  };

  const HandleMatchesWrapper = (index) => {
    let _match = true;

    // Table
    const SearchTable = $SearchTables?.[$CurrentStyle.StyleName] ?? _nullTable;

    // Check if filtered
    const _allRows = $RowsAllFiltered.map((e) => e.Row.toString());
    const _included = _allRows.includes(SearchTable["RowReferences"][index].toString());
    if (!_included) return false;

    // Datatip
    _match &= CheckMatchingCondition(dataTipValue, SearchTable["GanttBarTexts"][index], dataTipCondition);

    return _match;
  };

  const HandleMatchesWrapperRow = (rowToCheck) => {
    let _match = true;

    // Row
    _match &= CheckMatchingCondition(rowValue, rowToCheck, rowCondition);

    return _match;
  };

  const GetMatchingResults = () => {
    let _retArr = [];

    const SearchTable = $SearchTables?.[$CurrentStyle.StyleName] ?? _nullTable;

    if (tab === "ope") {
      for (let i = 0; i < SearchTable["GanttBarTexts"].length; i++) {
        // Minimalist check
        if (HandleMatchesWrapper(i)) {
          // Add match loc
          _retArr.push(
            [
              SearchTable["RowReferences"][i],
              SearchTable["PosReferences"][i]
            ]
          );
        }
      }
    }
    else if (tab === "row") {

      $RowsAllFiltered.forEach((el, i) => {
        // Minimalist check
        if (HandleMatchesWrapperRow(el.Alias)) {
          _retArr.push(i);
        }
      });
    }


    return _retArr;
  };

  const HighlightMatch = (e) => {
    matchs = GetMatchingResults();
    matchCount = matchs.length;
    currentMatch = 0;

    if (matchs.length > 0) {
      if (tab === "ope")
        JumpToDate(matchs[0]);
      else if (tab === "row")
        JumpToRow(matchs[0]);
    }
  };

  const MatchSelect = (off) => {
    currentMatch = Math.min(Math.max(0, matchs.length - 1), Math.max(0, currentMatch + off));

    if (matchs.length > 0) {
      if (tab === "ope")
        JumpToDate(matchs[currentMatch]);
      else if (tab === "row")
        JumpToRow(matchs[currentMatch]);
    }
  }

  const HandleTab = (t) => {
    tab = t;
    HighlightMatch();
  }


</script>

{#if Toggled === true}
  <div class="search_details">

    <div class="search_casesensitive">
      <label>
        <input
          type="checkbox"
          bind:checked={caseSensitive}
          on:change={HighlightMatch}
        />
        {translate("frontend:ganttChart.search.caseSensitive")}
      </label>
    </div>
    <div class="search_buttons">

      <select
        class="search_mode"
        bind:value={tab}
        on:change={HighlightMatch}
      >
        <option value="ope">{translate("frontend:ganttChart.search.operation")}</option>
        <option value="row">{translate("frontend:ganttChart.search.resource")}</option>
      </select>

      {#if matchCount === 0}
        <span class="search_pagination">0/0</span>
      {:else}
        <span class="search_pagination">{currentMatch + 1}/{matchCount}</span>
      {/if}
      <GeneralImgButton
        buttonImage="/assets/icon_page_up_blue.svg"
        buttonFunction={() => MatchSelect(-1)}
      />
      <GeneralImgButton
        buttonImage="/assets/icon_page_down_blue.svg"
        buttonFunction={() => MatchSelect(1)}
      />
    </div>

  </div>
{/if}

{#if tab === "ope"}
  <GeneralInput
    bind:value={dataTipValue}
    onInput={HighlightMatch}
    onClick={() => Toggled = true}
    extraStyle="
      width: 200px;
      margin-left: 8px;
      position:absolute;
      z-index: 99998;
      padding-left: 30px;
      background: url('/assets/icon_search_blue.svg') no-repeat 4px, white;
      background-size: 20px;
      top: 4px"
  />
{:else if tab === "row"}
  <GeneralInput
    bind:value={rowValue}
    onInput={HighlightMatch}
    onClick={() => Toggled = true}
    extraStyle="
      width: 200px;
      margin-left: 8px;
      position:absolute;
      z-index: 99998;
      padding-left: 30px;
      background: url('/assets/icon_search_blue.svg') no-repeat 4px, white;
      background-size: 20px;
      top: 4px"
  />
{/if}


{#if Toggled === true}
  <button on:click={() => Toggled = false} class="search_exit"></button>
{/if}


<style>
  .search_exit {
    position: absolute;
    background: url(/assets/icon_close_blue.svg) no-repeat;
    cursor: pointer;
    border: none;
    width: 16px;
    height: 16px;
    top: 12px;
    margin-left: 180px;
    z-index: 99999;
  }

  .search_exit:hover {
    background-color: #eeeeee;
  }

  .search_exit:active {
    background-color: #cccccc;
  }

  .search_mode {
    border: none;
    color: rgb(24, 67, 152);
    cursor: pointer;
  }

  .search_details {
    position: absolute;
    border: solid 1px rgb(24, 67, 152);
    border-radius: 5px;
    background-color: white;
    box-shadow: rgba(0, 0, 0, 0.2) 2px 0px 5px 0px;
    width: 216px;
    height: 120px;
    z-index: 99997;
    top: -4px;
    padding-top: 50px;
    display: flex;
    flex-direction: column;
  }

  .search_pagination {
    margin-left: auto;
    padding-right: 8px;
    margin-right: 2px;
    border-right: 1px solid #cccccc;
  }

  .search_tabs {
    overflow: hidden;
    border: 1px solid #ccc;
    background-color: #f1f1f1;
    margin-bottom: 15px;
  }

  .search_tab {
    background-color: inherit;
    float: left;
    border: none;
    outline: none;
    cursor: pointer;
    padding: 14px 16px;
    transition: 0.3s;
  }

  .search_tab:hover {
    background-color: #ddd;
  }

  .search_tab_active {
    background-color: #ccc!important;
  }

  div.search_casesensitive {
    display: flex;
    flex-direction: row;
    justify-content: center;
    width: 100%;
    font-size: 0.8em;
  }

  div.search_buttons {
    margin-top: auto;
    display: flex;
    align-items: center;
    justify-content: left;
    flex-direction: row;
    max-width: 100%;
    margin-left: 6px;
    margin-right: 6px;
    margin-bottom: 4px;
  }

  div.search_bar {
    margin-left: 10px;
    margin-right: 10px;
    gap: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: row;
    max-width: 100%;
  }

  div.search_top {
    max-width: 100%;
    padding-top: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    font-weight: bold;
    font-size: 16px;
  }

  .search_label {

  }

  .search_close {
    position: absolute;
    right: 10px;
  }

  div.search_bg {
    background-color: white;
    border: 2px solid rgb(40, 56, 93);
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    gap: 6px;
    padding-bottom: 10px;
  }

</style>
